<div class="absolute inset-0 overflow-y-auto p-3 sm:p-4 lg:p-6">
  <div class="mx-auto w-full max-w-5xl flex flex-col gap-4">
    <h1 class="text-xl sm:text-2xl xl:text-3xl font-bold tracking-tight text-gray-900">Einstellungen</h1>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 items-start">

    <!-- Change password -->
    <div class="bg-white rounded-lg border border-gray-100 shadow-sm p-4">
      <h3 class="text-base font-bold text-gray-800 tracking-tight mb-3">Passwort ändern</h3>
      <form class="flex flex-col">
        <app-password-entry [DarkMode]="false" [PasswordUtil]="passwordUtil"></app-password-entry>
        <button (click)="changePassword($event)" [disabled]="!passwordUtil.valid"
                class="mt-4 ml-auto inline-flex items-center gap-2 rounded-lg bg-theme-primary-600 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-theme-primary-100 transition-all duration-200 hover:bg-theme-primary-700 active:scale-95 disabled:opacity-40 disabled:grayscale disabled:cursor-not-allowed disabled:shadow-none"
                type="submit">
          <svg class="h-4 w-4" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>
          </svg>
          <span>Abschicken</span>
        </button>
      </form>
    </div>

    <!-- Calendar subscription -->
    <app-calendar-subscription></app-calendar-subscription>

    <!-- Kassen-PIN (self-service) — renders only for employees enabled for employee identification. -->
    <app-employee-pin-self class="md:col-span-2"></app-employee-pin-self>

    </div>
  </div>
</div>
